import { Box, Container } from '@material-ui/core';
import { PaymentMethodType, Product, Program } from '@nemuru-eng/js-api-client';

import { PricingFormWrapper } from '@/components/modules/PricingCreate/components/PricingFormWrapper';
import { PricingDataFormSchema } from '@/components/modules/PricingCreate/schemas/PricingDataFormSchema';
import { Font } from '@/components/shared/components/Font';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { Text } from '@/components/shared/components/Text';

import { PricingCreateFormValues } from '../types/PricingCreateFormValues';

interface PricingDataFormProps {
  formData: PricingCreateFormValues;
  onSubmit: (data: PricingCreateFormValues) => Promise<void>;
}

export const PricingDataForm = ({ formData, onSubmit }: PricingDataFormProps) => {
  return (
    <>
      <Container maxWidth={'sm'} style={{ marginLeft: 0, padding: 0 }}>
        <Font variant={'body1'} color={'textSecondary'}>
          <Text tId="CREATE_NEW_PRICING_DESCRIPTION" />
        </Font>
        <PricingFormWrapper defaultValues={formData} formSchema={PricingDataFormSchema} onSubmitForm={onSubmit}>
          <Box py={3} display={'flex'} flexDirection={'column'} gridGap={'16px'}>
            <TextFormField autoFocus name={'name'} label="NAME" />
            <TextFormField name={'description'} label="DESCRIPTION" />
            <SelectFormField
              name="program"
              label="PROGRAM"
              selectOptions={[Program.FREE_PROGRAM, Program.ZERO_PROGRAM, Program.NO_PURCHASE].map((program) => ({
                value: program,
                display: <Text tId={program} />,
              }))}
            />
            <SelectFormField
              name="product"
              label="PRODUCT"
              selectOptions={[Product.CONSUMER_LOAN, Product.AUTO, Product.CREDIT_LINE, Product.CARD].map(
                (product) => ({
                  value: product,
                  display: <Text tId={product} />,
                }),
              )}
            />
            <SelectFormField
              name={'paymentMethodType'}
              label={'PAYMENT_METHOD'}
              selectOptions={Object.values(PaymentMethodType).map((value) => ({
                value,
                display: <Text tId={value} />,
              }))}
            />
          </Box>
        </PricingFormWrapper>
      </Container>
    </>
  );
};
